import React, { useMemo } from 'react';
import { BsChevronDown, BsChevronExpand, BsChevronUp } from 'react-icons/bs';
import { useSortBy, useTable } from 'react-table';
import { Flex, Icon, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function ReactTable({ backgroundColor, color, tableData, tableColumns }) {
  const columns = useMemo(() => tableColumns, [tableColumns]);
  const data = useMemo(() => tableData, [tableData]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data
  }, useSortBy);

  return (
    <Table variant="simple" {...getTableProps()} pb={4}>
      <Thead>
        { headerGroups.map(headerGroup => (
          <Tr {...headerGroup.getHeaderGroupProps()}>
            { headerGroup.headers.map(column => (
              <Th
                {...column.getHeaderProps(column.getSortByToggleProps)}
                bg={backgroundColor || 'primaryScale.600'}
                color={color || 'white'}
                fontWeight="600"
                textAlign="center"
                textStyle="bodySm600"
                textTransform="none"
              >
                <Flex
                  alignItems="center"
                  justifyContent="center"
                >
                  {column.render('Header')}
                  {!column.defaultCanSort ? null : column.isSorted
                    ? column.isSortedDesc
                      ? <Icon as={BsChevronDown} ml={1} />
                      : <Icon as={BsChevronUp} ml={1} />
                    : <Icon as={BsChevronExpand} ml={1} />}
                </Flex>
              </Th>
            ))}
          </Tr>
        ))}
      </Thead>
      <Tbody {...getTableBodyProps()}>
        {
            rows.map(row => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()}>
                  {
                    row.cells.map(cell => (
                      <Td
                        {...cell.getCellProps()}
                        p={2}
                        textAlign="center"
                        textStyle="bodyMd"
                      >
                        {cell.render('Cell')}
                      </Td>
                    ))
                  }
                </Tr>
              );
            })
          }
      </Tbody>
    </Table>
  );
}

ReactTable.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  tableData: PropTypes.arrayOf(PropTypes.object),
  tableColumns: PropTypes.arrayOf(PropTypes.object)
};

export default ReactTable;
